import { pipe, prop, filter, map } from 'rambda';
import { TYPES } from './consts';
import { getName } from '../../treeVisitors/helpers';

const removeIgnoredMembers = (msg) => msg && !msg.ignore;
export const isEvent = (msg) => msg.isEvent;

export const isMainEntity = (msg) => msg.isMainEntity || msg.isMainObject;

export const trace = (label) => (data) => {
  console.log(label);
  console.log(`[DATA]::\n${JSON.stringify(data, null, 2)}`);
  return data;
};

const addDisplayNameToMainEntity = (msg) => ({
  ...msg,
  displayName: getName(msg),
});

const addSummaryAndDescriptionToGuides = (guide) => ({
  ...guide,
  docs: { summary: guide.content, description: '' },
});

export const getWebhooks = pipe(
  prop('data'),
  prop('events'),
  filter(removeIgnoredMembers),
);

export const getGuides = pipe(
  prop('data'),
  prop('relatedGuides'),
  map(addSummaryAndDescriptionToGuides),
);

export const getOperations = pipe(prop('data'), prop('operations'));

export const getMainEntity = pipe(
  prop('data'),
  prop('messages'),
  filter(removeIgnoredMembers),
  filter(isMainEntity),
  map(addDisplayNameToMainEntity),
);

export const getProperties = pipe(prop('data'), prop('properties'));
export const getClientEvents = pipe(prop('data'), prop('clientEvents'));

export const membersToFlatExtractors = {
  [TYPES.MD]: getGuides,
  [TYPES.OPERATION]: getOperations,
  [TYPES.WEBHOOK]: getWebhooks,
  [TYPES.MAIN_ENTITY]: getMainEntity,
  [TYPES.PROPERTY]: getProperties,
  [TYPES.CLIENT_EVENT]: getClientEvents,
};

export const extractHttpMethodFromOperationType = (type, data) => {
  if (type === TYPES.OPERATION) {
    return {
      extra: {
        httpMethod: data?.docs?.request,
      },
    };
  }
  return {};
};

export const extractTag = (guide) => guide.tag || guide.group;
